import { Component, OnInit, Inject, ViewChild, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { HistoryService } from './history.service';
import { User } from '../users/user.model';
import { HistoryGroup } from './history-group.model';
import { ErrorDialogComponent } from '../shared/error-dialog.component';
import { ConfirmDialogComponent } from '../shared/confirm-dialog.component';
import { CreateHistoryGroupComponent } from './create-history-group.component';

class GroupWithState extends HistoryGroup {
  targeted: boolean = false;
  loading: boolean = false;
}

@Component({
  selector: 'app-history-groups',
  templateUrl: './history-groups.component.html',
  styleUrls: ['./history-groups.component.scss']
})
export class HistoryGroupsComponent implements OnInit {

  availableUsers: User[] = [];
  groups: GroupWithState[] = [];
  mainGroup: GroupWithState;
  selectedGroup: GroupWithState;
  users: User[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private historyService: HistoryService,
    private ngZone: NgZone) { }

  ngOnInit() {
    this.availableUsers = this.sortByName(this.data.users);
    this.mainGroup = new GroupWithState({
      name: "Available Users",
      users: this.availableUsers
    })
    this.groups = this.data.groups.map((g) => {
      let group = new GroupWithState(g);
      group.users = this.sortByName(group.users);
      return group;
    });
    this.selectGroup(this.mainGroup);
  }

  selectGroup(group) {
    this.selectedGroup = group;
    this.users = group.users;
  }

  sortByName(named) {
    return named.slice().sort((a,b) => {
      return a.name.localeCompare(b.name, 'us', {
        sensitivity: "base",
        ignorePunctuation: true
      });
    })
  }

  showCreateDialog() {
    let dialogRef = this.dialog.open(CreateHistoryGroupComponent, {
      height: '240px',
      width: '320px',
      data: { }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result.name != null) {
        this.onCreate(result.name);
      }
    })
  }

  onCreate(name) {
    let group = new GroupWithState({name: name});
    group.loading = true;
    this.addGroup(group);
    this.historyService.createGroup(group).subscribe(
      (result) => {
        group.id = result.id;
        group.loading = false;
      },
      (error) => {
        this.removeGroup(group);
        this.ngZone.run(() => {this.showErrorDialog("Failed to create group")});
      }
    )
  }

  addGroup(group) {
    this.groups.push(group);
    this.groups = this.sortByName(this.groups);
    this.selectGroup(group);
  }

  confirmDelete(group) {
    let dialogRef = this.dialog.open(ConfirmDialogComponent, {
      height: '240px',
      width: '320px',
      data: {
        action: "Delete",
        message: "Delete group",
        question: group.name
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null && result.confirm === true) {
        this.onDelete(group);
      }
    })
  }

  onDelete(group) {
    this.removeGroup(group);
    this.historyService.deleteGroup(group).subscribe(
      (success) => { },
      (error) => {
        this.addGroup(group);
        this.ngZone.run(() => {this.showErrorDialog("Failed to delete group")});
      }
    )
  }

  removeGroup(group) {
    let index = this.groups.findIndex((g) => g.id === group.id)
    this.groups.splice(index, 1);
    if (this.selectedGroup === group) {
      this.selectGroup(this.mainGroup);
    }
  }

  onAddUser(user, group) {
    let inGroup = group.users.find((u) => u.id === user.id);
    if (inGroup != null) { return }
    group.loading = true;
    this.addUser(user, group);
    this.historyService.addUserToGroup(user, group).subscribe(
      (success) => {
        group.loading = false;
      },
      (error) => {
        this.removeUser(user, group);
        group.loading = false;
        this.ngZone.run(() => {this.showErrorDialog("Failed to add user")});
      }
    )
  }

  addUser(user, group) {
    group.users.push(user);
    group.users = this.sortByName(group.users);
    if (this.selectedGroup === group) {
      this.users = group.users;
    }
  }

  onRemoveUser(user, group) {
    group.loading = true;
    this.removeUser(user, group);
    this.historyService.removeUserFromGroup(user, group).subscribe(
      (success) => {
        group.loading = false;
      },
      (error) => {
        this.addUser(user, group);
        group.loading = false;
        this.ngZone.run(() => {this.showErrorDialog("Failed to add user")});
      }
    )
  }

  removeUser(user, group) {
    let index = group.users.findIndex((u) => u.id === user.id)
    group.users.splice(index, 1);
    if (this.selectedGroup === group) {
      this.users = group.users;
    }
  }

  showErrorDialog(message) {
    let dialogRef = this.dialog.open(ErrorDialogComponent, {
      height: '240px',
      width: '320px',
      data: {message: message}
    });
    setTimeout(() => dialogRef.close(), 6000);
  }

  onDragStart(event, user) {
    event.dataTransfer.setData('text', user.id)
  }

  onDragOver(event, group) {
    event.preventDefault();
    group.targeted = true;
    return false;
  }

  onDragLeave(event, group) {
    event.preventDefault();
    group.targeted = false;
    return false;
  }

  onDrop(event, group) {
    event.preventDefault();
    event.stopPropagation();
    if (group.id == null) { return }
    let id = event.dataTransfer.getData('text');
    let user = this.availableUsers.find((u) => u.id === id);
    if (user != null) {
      this.onAddUser(user, group);
    }
    group.targeted = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/history/history-groups.component.ts